export const getUserData = () => {
  try {
    const stored = localStorage.getItem('userData')

    return stored ? JSON.parse(stored) : {}
  } catch {
    return {}
  }
}
